












































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IEditableFormatStructure, FormatStructureEditor } from "../../../domain/editableFormat";
import { FormatDebuggableMixin } from "./mixins";

@Component
export default class FormatStructureTranslationTool extends Mixins(FormatDebuggableMixin) {
  @Prop()
  format: FormatStructureEditor;

  $refs!: {
    modelViewer: HTMLTextAreaElement;
    translatedViewer: HTMLTextAreaElement;
    sourceViewer: HTMLTextAreaElement;
    entityViewer: HTMLTextAreaElement;
  };

  selectAll(viewer: HTMLTextAreaElement): void {
    viewer.focus();
    viewer.select();
  }

  data() {
    return {
      isModelVisible: false,
      translated: null as any,
      source: null as any,
      isComplemented: false,
      entity: null as IEditableFormatStructure,
    };
  }
  isModelVisible: boolean;
  translated: any;
  source: any;
  isComplemented: boolean;
  entity: IEditableFormatStructure;

  get model(): IEditableFormatStructure {
    return this.format
      ? (this.format as any)._source._source  // 無理やり読む.（本来は禁止.デバッグ機能なので許容.真似しない事.）
      : null;
  }

  get modelAsString(): string {
    return this.isModelVisible
      ? this.stringifyOr(this.model, "データがありません.")
      : "";
  }

  get isTranslatedVisible(): boolean {
    return !!this.translatedAsString;
  }

  get translatedAsString(): string {
    return this.stringifyOr(
      this.isComplemented ? this.complementedTranslated : this.translated,
      null);
  }

  get complementedTranslated(): any {
    return this.toComplementedSource(this.translated);
  }

  async translateModel(): Promise<void> {
    this.translated = await this.registry.formatEditorDeveloper.getFormatService().translateFormatStructuteToSource(this.model, false);
  }

  get hasSource(): boolean {
    return !!this.model
        && !!this.model.id;
  }

  get isSourceVisible(): boolean {
    return this.hasSource
        && !!this.sourceAsString;
  }

  get sourceAsString(): string {
    return this.stringifyOr(
      this.isComplemented ? this.complementedSource : this.source,
      null);
  }

  get complementedSource(): any {
    return this.toComplementedSource(this.source);
  }

  async loadSource(): Promise<void> {
    this.source = await this.registry.formatEditorDeveloper.getFormatService().loadFormatStructureSource(this.model.id);
  }

  get isEntityVisible(): boolean {
    return !!this.entityAsString;
  }

  get entityAsString(): string {
    return this.stringifyOr(this.entity, null);
  }

  async translateBack(): Promise<void> {
    this.entity = await this.registry.formatEditorDeveloper.getFormatService().translateFormatStructuteFromSource(this.translated);
  }

  async translateSource(): Promise<void> {
    this.entity = await this.registry.formatEditorDeveloper.getFormatService().translateFormatStructuteFromSource(this.source);
  }
}
